import React from 'react';

import TripPlannerChatStats from './components/TripPlannerChatStats';

export default function TripPlannerChatStatsPage() {
  return <TripPlannerChatStats />;
}
